import { getToken, getUser, getToken2 } from "../Utils/Common";
import { getAPICall, postAPICall } from "./axiosMethodCalls";
import Moment from 'moment';

export const getDashboardLogs = async (date) => {
    try {
        const response = await getAPICall(process.env.REACT_APP_LINK + "dashboard/web", 
        {
            requester: getUser(),
            token: getToken(),
            bo_logs_date: Moment(date).format("YYYY-MM-DD"),
        })
        return { data: response.data }
    } catch (error) {
        return { error: error.response }
    }
}

export const getDashboardSummary = async (date) => {
    try {
        const response = await getAPICall(process.env.REACT_APP_LINK + "dashboard/summary", 
        {
            requester: getUser(),
            token: getToken(),
            current_date: Moment(date).format("YYYY-MM-DD"), //default line uncomment if not using code below
            //current_date: Moment(date).subtract(2, 'days').format("YYYY-MM-DD"), // use for testing if current date displays no data
        })
        return { data: response.data }
    } catch (error) {
        return { error: error.response }
    }
}

export const getDashboardLogsPotato = async (date) => {
    try {
        const response = await getAPICall(process.env.REACT_APP_POTATO + "dashboard/web", 
        {
            requester: getUser(),
            token: getToken2(),
            bo_logs_date: Moment(date).format("YYYY-MM-DD"),
        }, "potato")
        return { data: response.data }
    } catch (error) {
        return { error: error.response }
    }
}